import React, {useState} from 'react';

import getShapeBounds from '../../../libs/get-shape-bounds';

import Canvas from '../../map/canvas';
import AreaShape from '../../map/area-shape';
import {IArea} from '../../../interfaces/store';

import styles from '../../map/map.styl';

type IProps = {area: IArea; onInit: () => void};

/**
 * The map container
 */
const Map = ({area, onInit}: IProps): JSX.Element | null => {
  const [mapCanvas, setMapCanvas] = useState<ol.Map | null>(null);

  if (!area.shape || !area.center) {
    return null;
  }

  const bounds = getShapeBounds(area.shape, 1.05);

  return (
    <div className={styles.printMap}>
      <Canvas
        bounds={bounds}
        center={area.center}
        zoom={14}
        printVersion={true}
        onInit={canvas => {
          setMapCanvas(canvas);
          onInit();
        }}
      />

      {mapCanvas && <AreaShape mapCanvas={mapCanvas} shape={area.shape} edit={false}/>}
    </div>
  );
};

export default Map;
